import { Component, Entity, registerComponent, registerSystem, System, utils } from "aframe";
import { Light, Object3D } from "three";

type Map = { [key : string] : string[] };
export interface LayersSystem extends System
{
	data : string[]; //Names of layers
	maskOf( layers : string[] ) : number;
}


interface Rule
{
	filter : RegExp;
	mask : number;
}


interface LayersComponent extends Component
{
	system : LayersSystem;
	traverse : (obj : Object3D & { el? : Entity, originEl? : Entity }) => void;
	data : Map;
}

registerSystem("layers", {
	schema : { type : "array", default : ["Default"] },
	maskOf(this : LayersSystem, layers : string[])
	{
		let mask = 0;
		for(let layer of layers)
		{
			const ix = this.data.indexOf(layer);
			if(ix < 0)
			{
				console.warn("Unknown layer", layer);
				continue;
			}
			mask |= (1 << ix);
		}
		return mask;
	}
});



registerComponent("layers", {
	schema : { "" : { type : "array" } },
	init(this:  LayersComponent)
	{
		this.el.addEventListener("object3dset", (event) => this.traverse(event.detail.object) );
	},
	update(this : LayersComponent)
	{
		const el = this.el, rules : Rule[] = [];
		for(let key in this.data)
			rules.push({ filter : new RegExp(key), mask: this.system.maskOf(this.data[key]) });
		
		this.traverse = (o) =>
		{
			if(o.el && (o.el !== el) && (o.originEl !== el)) return;

			let mask = 0;
			for(let rule of rules)
				if(rule.filter.test(o.name))
					mask |= rule.mask;
			o.layers.mask = mask || 1;

			for(let child of o.children)
				this.traverse(child as any);
		};

		this.traverse(el.object3D);
		//for(let type in this.el.object3DMap)
			//this.traverse( this.el.object3DMap[type] );
	}
});



interface ShadowLayersComponent extends Component
{
	data : string[];
}


registerComponent("shadow-layers", {
	schema : { type : "array" },
	init(this:  ShadowLayersComponent)
	{
		this.el.addEventListener("object3dset", (event) =>
		{
			const light = event.detail.object as Light;
			//if(event.detail.type == "light")
			if(light && light.isLight && light.castShadow && light.shadow)
				this.update({});
		});
	},
	update(this : ShadowLayersComponent)
	{
		const system = this.el.sceneEl!.systems.layers as LayersSystem;
		for(let key in this.el.object3DMap)
		{
			const light = this.el.object3DMap[key] as Light;
			if(light && light.isLight && light.castShadow && light.shadow)
			{
				light.shadow.camera.layers.mask = system.maskOf(this.data);
			}
		}
	}
})